import { useState, useEffect } from 'react'
import { changeChannelName } from '../utils/network'
import showAlert from 'utils/showAlert'

const useChangeChannelName = props => {
    const { channelName, appId, channelKey, onHideDialog } = props

    const [showEdit, setShowEdit] = useState(false)
    const [content, setContent] = useState(channelName)
    const [theChannelName, setChannelName] = useState(channelName)
    const [status, setStatus] = useState('success')
    const [helpBlock, setHelpBlock] = useState('渠道包名符合长度要求')

    useEffect(() => {
        setChannelName(channelName)
        setContent(channelName)
    }, [channelName])

    const handleFormDataChange = val => {
        setContent(val)
        if (val.length < 2) {
            setStatus('error')
            setHelpBlock('渠道包名长度不能小于2')
        } else if (val.length > 128) {
            setStatus('error')
            setHelpBlock('渠道包名长度不能大于128')
        } else {
            setStatus('success')
            setHelpBlock('渠道包名符合长度要求')
        }
    }
    const handleMouseOver = () => {
        setShowEdit(true)
    }
    const handleMouseLeave = () => {
        setShowEdit(false)
    }

    const handleSubmit = () => {
        const ModifyNameRequest = {
            appId: appId,
            channelKey: channelKey,
            channelName: content,
        }
        changeChannelName(ModifyNameRequest).then(
            res => {
                if (res.c === 200) {
                    showAlert('success', '修改渠道包名称成功')
                    setChannelName(content)
                    onHideDialog()
                } else {
                    setStatus('error')
                    setHelpBlock(res.d)
                }
            },
            e => {
                showAlert('error', '请求数据发生错误')
            }
        )
    }

    return {
        content,
        showEdit,
        theChannelName,
        status,
        helpBlock,
        handleFormDataChange,
        handleMouseOver,
        handleMouseLeave,
        handleSubmit,
    }
}

export default useChangeChannelName
